<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { ADMIN_STATS } from '@/store/types';
import statsApi from '@/services/apis/admin/statistics.api';

export default {
  props: {
    type: {
      type: String,
      default: 'monthly',
    },
    from: String,
    to: String,
    employer_id: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    const store = useStore();
    const query = ref(null);
    query.value = statsApi.useAvgCommuteModeDistanceQuery({
      type: props.type,
      from: props.from,
      to: props.to,
      employer_id: props.employer_id,
    });
    if (query.value) {
      store.commit(ADMIN_STATS.SET_AVG_COMMUTE_MODE_DISTANCE_STATS_QUERY, query);
    }
    return { query };
  },
};
</script>
